// Mirrors GET /esp-plan-manager/v1/plans/{plan-id}/external-forecast (ESP-22440 spec §5.1).

export interface ExternalForecastMonth {
  /** yyyy-MM */
  month: string;
  contactsReceived: number;
  /** True if the plan covers fewer days of this month than the month has. */
  partial: boolean;
}

export interface ExternalForecastYear {
  year: number;
  /** Exact server-side sum of months[].contactsReceived. The client never recomputes it. */
  total: number;
  months: ExternalForecastMonth[];
}

export interface ExternalForecastComparison {
  planId: string;
  /** yyyy-MM-dd */
  planStartDate: string;
  /** yyyy-MM-dd */
  planEndDate: string;
  /** ISO-8601 UTC instant */
  snapshotAt: string;
  /** Ascending by year, no gaps. */
  years: ExternalForecastYear[];
}

export enum ExternalForecastErrorId {
  DISABLED = "EXTERNAL_FORECAST_DISABLED",
  PLAN_NOT_FOUND = "PLAN_NOT_FOUND",
  FEATURE_STATUS_UNAVAILABLE = "EXTERNAL_FORECAST_FEATURE_STATUS_UNAVAILABLE"
}
